import React from 'react';
import ErrorReporter from 'app/components/ErrorReporter';
import OverlayLoading from 'components/OverlayLoading';
import './styles/Navigation.scss';

import { NavigationItem } from './NavigationItem';
import { NavigationSection, NavigationSectionProps } from './NavigationSection';

export type NavigationProps = {
  error?: boolean;
  loading?: boolean;
  sections: ({ key: string } & NavigationSectionProps)[];
  allUnreads?: number;
};

const Navigation = ({ error, loading, sections, allUnreads = 0 }: NavigationProps): JSX.Element => {
  if (error) {
    return <ErrorReporter error="NavigationList - failed to load navigation sections" />;
  }

  return (
    <div className="Navigation">
      {loading && <OverlayLoading />}

      <nav>
        {sections.map(section => (
          <NavigationSection {...section} />
        ))}

        <ul className="NavigationSection">
          <NavigationItem
            key="none"
            title="All conversations"
            image={require('assets/images/avatars/home.svg')}
            unreadCount={allUnreads}
            to="/classes/r"
          />
        </ul>
      </nav>
    </div>
  );
};

export default Navigation;
